import React from "react";
import { Popover, PopoverHeader, PopoverBody } from "reactstrap";
import StackAndAlign from "./StackAndAlign";
import "./RightSideModal.css";

const RightSideModal = ({
  showModal,
  setShowModal,
  selectionManager,
  getObjectKey,
  items,
  historyManager,
  projectId,
  currentRoom,
  loadRoom,
  targetRef,
  forceUpdate,
  cameraView,
}) => {
  const togglePopover = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <Popover
        placement="bottom"
        isOpen={showModal}
        target={targetRef.current}
        toggle={togglePopover}
        offset={[-60, 10]}
        className="popover-container"
      >
        <div className="popover-container">
          <PopoverHeader className="popover-header">
            <span>Position</span>
            <i
              onClick={() => setShowModal(false)}
              className="fa-solid fa-close pointer fs-5 close-icon"
            />
          </PopoverHeader>
          <PopoverBody className="popover-body">
            <StackAndAlign
              selectionManager={selectionManager}
              getObjectKey={getObjectKey}
              items={items}
              historyManager={historyManager}
              projectId={projectId}
              currentRoom={currentRoom}
              loadRoom={loadRoom}
              forceUpdate={forceUpdate}
              cameraView={cameraView}
            />
          </PopoverBody>
        </div>
      </Popover>
    </>
  );
};

export default RightSideModal;
